enum PendingTasksActionEnum {
  CREDENTIAL_BEING_PROCESSED = 'CREDENTIAL_BEING_PROCESSED',
  CREDENTIAL_PROCESSED = 'CREDENTIAL_PROCESSED',
}

export default PendingTasksActionEnum;
